export const event = 'GAevent';

export const category = Object.freeze({
  INTERACTION: 'Interaction',
  CONVERSION: 'Conversion',
  VIEW: 'view',
  LEAD_EMAIL: 'lead.email',
  LEAD_PHONE: 'lead.phone',
  TAKE_ACTION: 'takeaction.intent',
  OUTBOUND_LINK: 'Outbound Link',
});
